export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7459.085fc008.jpg";